import React from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {contactWhatsAppUrl, contactPhone,contactSnapChatUrl,contactFacebookUrl,contactInstagramUrl} from '../../utils/constants';
import { makeStyles } from "@mui/styles/";
import { Typography } from '@mui/material';
import { useHistory, useParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import Logo from '../../components/Logo';
import Whatsapp from '../../components/icons/whatsapp';
import Email from '../../components/icons/email';
import Location from '../../components/icons/location';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocation,faMessage ,faLocationPin , } from '@fortawesome/free-solid-svg-icons';
import firebase from 'firebase';
import { useSelector } from 'react-redux';
const useStyles = makeStyles({
    mainContainer: {
        // paddingTop: StatusBar.currentHeight
        // paddingHorizontal: 10,
    },
    details: {
        marginTop: 0,
        marginBottom: 0,
    },
    centerElement: { display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center" },
    filterButton: { padding: 10, bottom: 10, marginTop: 40,  elevation: 3, borderRadius: 20 },
   
    phoneText: { textAlignVertical: "center",  fontWeight: "400", fontSize: 15, marginLeft: 10, },
    search: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginHorizontal: 20,
        marginTop:10
    },
});

const ContactUsScreen = ({ }) => {
    const navigation = useHistory();
    const { t } = useTranslation();
    const styles = useStyles();
  const customTheme = useTheme();
  const currentUser = useSelector((state) => state.auth.user);
    return (
        <div style={{ flex: 1, backgroundColor: customTheme.light.white }}>
            <div>
                <div className={styles.mainContainer}>
                     <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignContent: "center",  marginTop: 20 }} >
                    <Logo withNavigation={true} width={600} height={400} />
                    </div>
<div style={{display:"flex", flexDirection:"row" , justifyContent: "space-between", width:"100%",  paddingInline:40}}>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignContent: "center", marginHorizontal: 10, marginTop: 20, }} >
                        <Location
                              width={35}
                              height={35}
                            />
                        <Typography className={styles.details} style={{color: customTheme.light.dark,
        marginLeft: 10,
        fontSize: 16, alignSelf: "center", }}>{"UAE"}</Typography>
                    </div>
                    <div
                        style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignContent: "center", marginHorizontal: 10, marginTop: 20 }}
                    >
                              <Email
                            width={35}
                            height={35}
                            />
                        <Typography className={styles.details} style={{ color: customTheme.light.dark,
        marginLeft: 10,
        fontSize: 16,alignSelf: "center", textDecorationLine: "underline" }}>{"WhizzAroundApp@gmail.com"}</Typography>
                    </div>
                    <div 
                     style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignContent: "center", marginHorizontal: 15, marginTop: 20 }} >
                        <Whatsapp
                            width={35}
                            height={35}
                            />
                        <Typography className={styles.phoneText} style={{alignSelf:"center",marginInline:10, color: customTheme.light.dark,textAlign: "center" ,textDecorationLine: "underline" }}>{contactPhone}</Typography>
                    </div>
                    </div>
                    {currentUser && !currentUser?.isAnonymous && <div style={{display:"flex", flexDirection:"row",width:"100%", justifyContent: "center",  alignItems:"flex-end" }} >
                        <div
                            className={styles.filterButton}
                            onClick={()=>navigation.push("/contact-us-support")}
                            style={{cursor:"ponter",width:"50%",display: "flex",backgroundColor: customTheme.light.primary, flexDirection: "row", justifyContent: "center", alignItems: "center"}}
                        >
                            <FontAwesomeIcon
                              icon={faMessage}
                              style={{ fontSize: 35, color: customTheme.light.primary }}
                            />
                            <Typography style={{ color: '#fff', fontSize: 17, marginHorizontal: 10 }}>{t("screens.customer-support")}</Typography>
                        </div>
                    </div>} 
                </div>
            </div>
        </div>
    )
}

export default ContactUsScreen;